import { useObserver } from 'mobx-react';
import useMst from '~/src/hooks/useMst';
import useResourcePagination from '~/src/hooks/useResourcePagination';
import { SortByOrder } from '~/src/hooks/sortByOrder';
import { CourtFormSortByOption } from '~/src/hooks/courtFormSortByOption';

const usePdfLocalitiesPagination = (requestPayload) => {
  const { pdfLocalities } = useMst((store) => ({
    pdfLocalities: store.pdfLocalities,
  }));

  const { loading, next, page, empty, setSearch, done, setSortBy, setOrder } =
    useResourcePagination(
      {
        fetch: pdfLocalities.fetch,
        limit: 10,
        order: SortByOrder.asc,
        sortBy: CourtFormSortByOption.locality,
      },
      requestPayload,
    );

  const listData = useObserver(() => {
    return pdfLocalities.list.flat();
  });

  return {
    next,
    page,
    empty,
    data: listData,
    loading,
    done,

    setSearch,
    setSortBy,
    setOrder,
  };
};

export default usePdfLocalitiesPagination;
